
/**
 * 링크 유형 (외부 링크 또는 프로젝트 링크)
 */
export type TopicResponseMediaLinksItemLinkType = typeof TopicResponseMediaLinksItemLinkType[keyof typeof TopicResponseMediaLinksItemLinkType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TopicResponseMediaLinksItemLinkType = {
  EXTERNAL: 'EXTERNAL',
  PROJECT: 'PROJECT',
} as const;
